import OspCol from './OspCol.vue';

export default OspCol;



// WEBPACK FOOTER //
// ./src/components/OspCol/index.js